import React from 'react';
import './AuthFooter.scss';

const currentYear = new Date().getFullYear();

export default function AuthFooter() {
  return (
    <footer className="AuthFooter">
      <span>© {currentYear} The Host Co</span>
      <a href="https://www.thehost.co/terms-conditions">Terms</a>
      <a href="https://www.thehost.co/privacy-policy">Privacy</a>
      <a href="mailto:support@thehost.co">Contact us</a>
    </footer>
  );
}
